import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

import type { JiraStoriesSyncStatus } from '@/domain/models/development.js';

interface Props {
    status: JiraStoriesSyncStatus;
    generatingLabel: string;
    creatingLabel: string;
    doneLabel: string;
    retryLabel: string;
}

export function JiraStoriesStatus({ status, generatingLabel, creatingLabel, doneLabel, retryLabel }: Props) {
    if (status === 'GENERATING' || status === 'CREATING') {
        return (
            <Box data-testid="jira-stories-status" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <CircularProgress size={14} data-testid="jira-stories-status-loader" />
                <Typography variant="body2">{status === 'GENERATING' ? generatingLabel : creatingLabel}</Typography>
            </Box>
        );
    }
    if (status === 'RETRYING') {
        return (
            <Typography variant="body2" data-testid="jira-stories-status" sx={{ mb: 2 }}>
                {retryLabel}
            </Typography>
        );
    }
    if (status === 'DONE') {
        return (
            <Typography variant="body2" data-testid="jira-stories-status" sx={{ mb: 2 }}>
                {doneLabel}
            </Typography>
        );
    }
    return null;
}
